import { TFunction } from 'i18next'

import { RecurringInvoiceEventType } from '@features/recurringInvoices/enums/recurringInvoiceEventType'

const recurringInvoiceEventTypeToTKey = {
  [RecurringInvoiceEventType.ProfileAccountingComplianceFail]:
    'recurring_invoices.page.timeline.status.profile.accounting.comply.failed',
  [RecurringInvoiceEventType.ProfileCompleted]: 'recurring_invoices.page.timeline.status.profile.completed',
  [RecurringInvoiceEventType.ProfileCreated]: 'recurring_invoices.page.timeline.status.profile.created',
  [RecurringInvoiceEventType.ProfileDeleted]: 'recurring_invoices.page.timeline.status.profile.deleted',
  [RecurringInvoiceEventType.ProfileDocumentCreated]:
    'recurring_invoices.page.timeline.status.profile.document.created',
  [RecurringInvoiceEventType.ProfileDocumentDraftCreated]:
    'recurring_invoices.page.timeline.status.profile.document.draft.created',
  [RecurringInvoiceEventType.ProfileEdited]: 'recurring_invoices.page.timeline.status.profile.edited',
  [RecurringInvoiceEventType.ProfilePaused]: 'recurring_invoices.page.timeline.status.profile.paused',
  [RecurringInvoiceEventType.ProfileScheduleActionFail]:
    'recurring_invoices.page.timeline.status.profile.scheduler.action.failed',
  [RecurringInvoiceEventType.ProfileScheduleActionFailSend]:
    'recurring_invoices.page.timeline.status.profile.scheduler.action.failed.send',
  [RecurringInvoiceEventType.ProfileScheduleActionSuccess]:
    'recurring_invoices.page.timeline.status.profile.scheduler.action.succeeded',
  [RecurringInvoiceEventType.ProfileScheduleSubscriptionFail]:
    'recurring_invoices.page.timeline.status.profile.scheduler.subscription.failed',
  [RecurringInvoiceEventType.ProfileStarted]: 'recurring_invoices.page.timeline.status.profile.started',
}

export const getRecurringHistoryStatusEventLabel = (eventType: RecurringInvoiceEventType, t: TFunction) => {
  return t(recurringInvoiceEventTypeToTKey[eventType]) || eventType
}
